import React, { useContext, useState } from "react";
import classNames from "classnames/bind";
import styles from "./Table.module.css";
import emptyImage from "../../../../../assets/images/Emty.png";
import { LisencePlateManagerContext } from "../../../../../contexts";
import { formatDDMMYY } from "../../../../../utils";
import { Pagination, Table as TB } from "../../../../../components";
import { EditIcon } from "../../../../../components/Icons/Icons";

const cx = classNames.bind(styles);
const Table = ({ pages, currentPage, getPage, data }) => {
  const { cameraCode, nameService } = useContext(LisencePlateManagerContext);
  const [isLoading, setIsLoading] = useState(false)

  const dataTb = data?.map((item, index) => {
    return {
      stt: index + 1,
      time: item?.TIME ? formatDDMMYY(item.TIME) : '',
      lisence_plate: item?.LICENSE_PLATE ? item.LICENSE_PLATE : '',
      img_lisence_plate: item?.LICENSE_PLATE_IMAGE ? (
        <div>
          <img src={`${process.env.REACT_APP_BASE_URL}event${item.LICENSE_PLATE_IMAGE}`} />
        </div>
      ) : '',
      action: <div style={{ textAlign: 'center' }} ><EditIcon /></div>
    }
  })

  const columns = [
    {
      label: <div className={cx('center')} style={{ width: '40%' }}>STT</div>,
      key: "stt",
    },
    {
      label: 'Thời gian',
      key: "time",
    },
    {
      label: "Biển số",
      key: "lisence_plate",
    },
    {
      label: "Hình ảnh biển số",
      key: "img_lisence_plate",
    },
    {
      label: <div className={cx('center')} >Hành động</div>,
      key: "action",
    },
  ];

  const handleNext = () => {
    getPage(currentPage + 1)
  }
  const handlePrevious = () => {
    getPage(currentPage - 1)
  }

  const handleChosePage = (data) => {
    getPage(data)
  }

  const handleClose = () => {
    setIsLoading(false)
  }
  return (
    <div>
      <TB data={dataTb} colum={columns} />
      {data?.length === 0 && cameraCode && (
        <div className={cx("empty")}>
          <img src={emptyImage} alt="no-record" className={cx('empty-img')} />
          <p>Không có bản ghi trong thời gian được chọn</p>
        </div>
      )}
      {data?.length === 0 && !cameraCode && (
        <div className={cx("empty")}>
          <p>Vui lòng lựa chọn camera để xem video {nameService?.toLowerCase()}!</p>
        </div>
      )}
      {data?.length > 0 && (
        <div className={cx("pagination")}>
          <Pagination pages={pages} currentPage={currentPage} onNext={handleNext} onPrevious={handlePrevious} onClick={e => handleChosePage(e)} />
        </div>
      )}
    </div>
  );
};

export default Table;
